import { useAutoAnimate } from '@formkit/auto-animate/react'
import React from 'react'

interface CollapsibleProps {
  className?: string
  isOpen: boolean
}

const Collapsible: React.FC<React.PropsWithChildren<CollapsibleProps>> = (
  props,
): React.ReactElement => {
  const [containerRef] = useAutoAnimate()

  return (
    <div ref={containerRef} className={props.className}>
      {props.isOpen && props.children}
    </div>
  )
}

export default Collapsible
